import { render, staticRenderFns } from "./LiveOrderTab.vue?vue&type=template&id=586ae50c&scoped=true"
import script from "./LiveOrderTab.vue?vue&type=script&lang=js"
export * from "./LiveOrderTab.vue?vue&type=script&lang=js"
import style0 from "./LiveOrderTab.vue?vue&type=style&index=0&id=586ae50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586ae50c",
  null
  
)

export default component.exports